import ConsultWaitTimeIndicator from "../../components/ConsultWaitTimeIndicator";
import SmartRecruitersWidget from "../pages/careers/SmartRecruitersWidget";
import { NON_STATIC_COMPONENT_IDS } from "../constants";

const NON_STATIC_COMPONENTS = {
	[NON_STATIC_COMPONENT_IDS.WAIT_TIME_CONSULT_BOOK]: ConsultWaitTimeIndicator,
	[NON_STATIC_COMPONENT_IDS.SMART_RECRUITERS_WIDGET]: SmartRecruitersWidget,
};

export const NonStaticComponents = ({ componentId, isStatic, props }) => {
	const Component = NON_STATIC_COMPONENTS[componentId];

	if (!Component) {
		console.warn("NonStaticHeaderComponents: Unknown componentId", componentId);
		return null;
	}

	return <Component isStatic={isStatic} {...props} />;
};
